import * as THREE from "three";

/** Counts the submitted triangles owned by a mech, excluding constructor-only helpers. */
export function countMeshTriangles(root: THREE.Object3D | null): number {
  if (root == null) return 0;
  let triangles = 0;
  root.traverse((object) => {
    if (!(object instanceof THREE.Mesh) || !object.visible) return;
    if (object.userData.constructorHelper === true) return;
    const geometry = object.geometry;
    const available = geometry.index?.count ?? geometry.getAttribute("position")?.count ?? 0;
    const availableFromStart = Math.max(0, available - geometry.drawRange.start);
    const drawCount = Number.isFinite(geometry.drawRange.count)
      ? Math.min(availableFromStart, geometry.drawRange.count)
      : availableFromStart;
    const instances = object instanceof THREE.InstancedMesh ? object.count : 1;
    triangles += Math.floor(Math.max(0, drawCount) / 3) * instances;
  });
  return triangles;
}
